import React, { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { VideoCard } from "../Components/VideoCard";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import { VideoFrame } from "../Components/VideoFrame";
import { CalculateMonth } from "../Components/calculateMonth";
import { url, allVideosParam, categories } from "../config";

export const VideoPage = () => {
  const [videosData, setVideosData] = useState();
  const [videoData, setVideoData] = useState({});
  const params = useParams();
  const history = useHistory();

  const redirectToHome = () => {
    history.push("/");
  };

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      setVideosData(response.data.videos);
    } catch (error) {
      console.log(error.response);
    }
  };

  // const fetchVideo = async (url) => {
  //   try {
  //     const response = await axios.get(url);
  //     setVideoData(response.data);
  //   } catch (error) {
  //     console.log(error.response);
  //   }
  // };

  const patchUpdates = async (url, obj) => {
    try {
      const rezz = await axios.patch(url, obj);
      setVideoData(rezz.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    fetchData(url + allVideosParam);
    // fetchVideo(url + `${allVideosParam}/${params.id}`);
    patchUpdates(url + allVideosParam + `/${params.id}/` + categories.views);
  }, []);

  // useEffect(() => {
  //   fetchVideo(url + `${allVideosParam}/${params.id}`);
  // }, [params.id]);

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        bgcolor="#202020"
        padding="13px"
      >
        <Typography
          color="#FFFFFF"
          fontSize="24px"
          sx={{ cursor: "pointer" }}
          onClick={() => redirectToHome()}
        >
          <span className="xFlix">X</span>Flix
        </Typography>
      </Box>
      <VideoFrame
        id={videoData._id}
        src={videoData.videoLink}
        title={videoData.title}
        viewCount={videoData.viewCount ? videoData.viewCount : 0}
        genre={videoData.genre}
        patchFunc={patchUpdates}
        time={CalculateMonth(videoData.releaseDate)}
        upV={videoData.votes ? videoData.votes.upVotes : 0}
        downV={videoData.votes ? videoData.votes.downVotes : 0}
      />
      <Box sx={{ px: 10, paddingTop: 3 }} bgcolor="#181818">
        <Box height="1px" bgcolor="rgba(216, 216, 216, 0.5)"></Box>
      </Box>
      <Box bgcolor="#181818" height="120%" sx={{ paddingTop: 2 }}>
        <Grid container spacing={2} sx={{ px: 10 }} marginTop="0">
          {videosData &&
            videosData.map((card) => (
              <Grid item xs={6} md={3}>
                <VideoCard
                  image={card.previewImage}
                  videoTitle={card.title}
                  videoId={card._id}
                  time={CalculateMonth(card.releaseDate)}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  );
};
